import React from 'react'
import {makeStyles, withStyles  } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#00A9E2',
      color: '#fff',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #00A9E2',
     
    },
    arrow: {
        color: '#00A9E2',
      },
  }))(Tooltip);
  const useStyles = makeStyles(() => ({
    
    customWidth: {
      maxWidth: 500
    }
  }));
export default function Tooltips(props) {
  const classes = useStyles();

  const displayMessage = ()=>{
    return <React.Fragment>
    <div dangerouslySetInnerHTML={{__html: props.values.userClassTooltips}} ></div>
  </React.Fragment>
  }
    return (
        <React.Fragment>
      <HtmlTooltip  
        disableFocusListener
        classes={{ tooltip: classes.customWidth }}
        placement="right"
        arrow={true}
        interactive={true}
        enterTouchDelay={-100}
        leaveTouchDelay={5000}
        PopperProps={{
          modifiers: {
            arrow: {
              enabled: true,
              // Adjust the offset to move the arrow higher
              offset: [0, -10],
            },
          },
        }}
        title={displayMessage()}
      ><HelpOutlineOutlinedIcon 
        fontSize="medium"
        style={{cursor:"pointer"}}/>
      </HtmlTooltip>  
      </React.Fragment>
    )
}
